import script from "./ImportTeresaStandard.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportTeresaStandard.vue?vue&type=script&setup=true&lang=js"

import "./ImportTeresaStandard.vue?vue&type=style&index=0&id=7a959101&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a959101"]])

export default __exports__